"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";
import { isServerActionNotFoundError } from "@/lib/serverActionUtils";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const isStaleServerAction = isServerActionNotFoundError(error);

  useEffect(() => {
    // 배포 교체로 자동 복구되는 stale Server Action 에러는 Sentry 노이즈를 만들지 않고
    // 새로고침만 한다. 그 외 진짜 에러만 Sentry에 보고.
    if (isStaleServerAction) {
      const timer = window.setTimeout(() => {
        window.location.reload();
      }, 1500);

      return () => window.clearTimeout(timer);
    }

    Sentry.captureException(error);
  }, [error, isStaleServerAction]);

  if (isStaleServerAction) {
    return (
      <html lang="ko">
        <body>
          <main
            style={{
              alignItems: "center",
              display: "flex",
              minHeight: "100vh",
              justifyContent: "center",
              padding: 16,
            }}
          >
            <div style={{ maxWidth: 420, textAlign: "center" }}>
              <h2>페이지가 업데이트되었습니다</h2>
              <p>새 버전과 연결하기 위해 페이지를 새로고침합니다.</p>
              <button type="button" onClick={() => window.location.reload()}>
                지금 새로고침
              </button>
            </div>
          </main>
        </body>
      </html>
    );
  }

  return (
    <html lang="ko">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
